let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5uN9h")).then(() => parcelRequire('69PnT'));